import { HttpHeaders } from '@angular/common/http';
import { EventEmitter, Injectable, Output } from '@angular/core';
import { BaseService } from './base.service';
import { map } from 'rxjs/operators';




@Injectable()
export class AuthService extends BaseService {
  @Output() done: EventEmitter<any> = new EventEmitter();

  login(username: string, password: string, otp: string) {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });

    const credentials = {
      username: username.trim().toLowerCase(),
      password,
      otp,
      lang: this.lang
    };

    return this.http.post(this.url + 'api/auth', credentials, { headers });

  }

  reauthenticate() {

    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'token': this.token
    });
    return this.http.post(this.url + 'api/account/check_token', {}, { headers: headers });

  }

  sendLocation(latitude, longitude) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'token': this.token
    });
    return this.http.post(this.url + 'api/location/create', { latitude, longitude }, { headers: headers });
  }

  sendMessage(token: string) {
    this.socket.emit('auth', token);
  }

  getCall() {
    return this.socket.fromEvent('call').pipe(map((data: any) => data.account));
  }

  changePassword(newPassword: string) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'token': this.token
    });
    const body = {
      newPassword: newPassword
    };

    return this.http.post(this.url + 'api/account/change_password', body, { headers: headers });
  }

  resetPassword(username: string) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'token': this.token
    });

    return this.http.post(this.url + 'api/account/reset_password', { username }, { headers: headers });
  }
}
